import { AnimatePresence } from 'framer-motion';
import { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import About from './components/about/About';
import Contact from './components/contact/Contact';
import Cursor from './components/cursor/Cursor';
import Footer from './components/footer/Footer';
import Header from './components/header/Header';
import Home from './components/home/Home';
import PreLoader from './components/preloader/Preloader';
import Qualification from './components/qualification/Qualification';
import ScrollUp from './components/scrollup/ScrollUp';
import Services from './components/services/Services';
import Skills from './components/skills/Skills';
import Testimonials from './components/testimonials/Testimonials';
import Work from './components/work/Work';
import SellerHelp from './pages/SellerHelp';
import SellerHome from './pages/SellerHome';

// Component to manage body classes based on route
const RouteManager = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    const isSellerPage = location.pathname.startsWith('/seller');
    
    if (isSellerPage) {
      document.body.classList.add('seller-page');
    } else {
      document.body.classList.remove('seller-page');
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('seller-page');
    };
  }, [location.pathname]);

  return children;
};

// Main Portfolio Component
const MainPortfolio = () => (
  <>
    <Header />
    <main className="main">
      <Home />
      <About />
      <Skills />
      <Services />
      <Qualification />
      <Testimonials />
      <Work />
      <Contact />
    </main>
    <Footer />
    <ScrollUp />
  </>
);

const App = () => {
  const [loading, setLoading] = useState(true);

  return (
    <BrowserRouter>
      <RouteManager>
        <Cursor />
        <AnimatePresence mode="wait">
          {loading && <PreLoader setLoading={setLoading} />}
        </AnimatePresence>
        {!loading && (
          <Routes>
            <Route path="/" element={<MainPortfolio />} />
            <Route path="/seller" element={<SellerHome />} />
            <Route path="/seller/help" element={<SellerHelp />} />
            <Route path="*" element={<MainPortfolio />} />
          </Routes>
        )}
      </RouteManager>
    </BrowserRouter>
  );
}

export default App;
